import { QuestionCircled } from 'education-icons';
import { Link, Text, useIntl } from 'platform-components';
import { UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/src/components/constants';
import React from 'react';

import './portfolio__how-to-print.scss';

const HowToPrint = () => {
    const intl = useIntl();

    return (
        <div className="portfolio__how-to-print how-to-print">
            <Link
                mix="how-to-print__wrapper"
                target="_blank"
                theme={Link.THEME.ABSTRACT}
                to={intl.formatMessage({ id: 'teacherPortfolio.howToPrint.url' })}
            >
                <div className="how-to-print__question-icon-wrapper">
                    <QuestionCircled className="how-to-print__question-icon" />
                </div>
                <Text
                    className="how-to-print__info-text"
                    id="teacherPortfolio.howToPrint"
                    typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}
                />
            </Link>
        </div>
    );
};

export default HowToPrint;
